module.exports = __webpack_public_path__ + "static/media/madbar-store.d6845d5c.png";